import { computed } from "vue";
import { useRoute } from "vue-router";
import { useQuery } from "@tanstack/vue-query";
import { getByIdRepairsQuery } from "@vendata/power-up-sdk/requests/repairs/get-by-id";
import { byRepairIdsMercuryTransactionAllocationsQuery } from "@vendata/power-up-sdk/requests/mercury-transaction-allocations/by-repair-ids";
import { listOrganizationsQuery } from "@vendata/power-up-sdk/requests/organizations/list";

export function useRepairDetailLoader() {
  const route = useRoute();
  const id = computed(() => String(route.params.id ?? ""));
  const repairIds = computed(() => (id.value ? [id.value] : []));

  return {
    repairQuery: useQuery(getByIdRepairsQuery({ id })),
    allocationsQuery: useQuery(
      byRepairIdsMercuryTransactionAllocationsQuery({ repairIds }),
    ),
    organizationsQuery: useQuery(listOrganizationsQuery()),
  };
}
